import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import deepmerge from 'deepmerge';
import defaultTheme from './theme';

const createPalette = _ref => {
  let {
    palette = {}
  } = _ref,
      theme = _objectWithoutPropertiesLoose(_ref, ["palette"]);

  const {
    colors,
    baseColors
  } = theme;
  const colorPalette = {
    luContent: {
      base: baseColors.shock.base,
      dark: baseColors.shock.dark,
      text: colors.white
    },
    primary: {
      base: colors.blue,
      dark: colors.darkBlue,
      text: colors.white
    },
    secondary: {
      base: colors.green,
      dark: colors.darkGreen,
      text: colors.white
    },
    error: {
      base: colors.red,
      text: colors.white
    },
    alert: {
      info: {
        base: baseColors.magablu.light,
        text: baseColors.magablu.dark
      },
      success: {
        base: baseColors.lima.light,
        text: baseColors.lima.dark
      },
      warning: {
        base: baseColors.pizza.light,
        text: baseColors.pizza.dark
      },
      danger: {
        base: baseColors.vermillion.light,
        text: baseColors.vermillion.dark
      }
    },
    text: {
      white: colors.base,
      base: colors.darkSilver,
      light: colors.gray,
      lighter: colors.silver,
      lightest: colors.white,
      dark: colors.black,
      primary: colors.blue,
      scratched: colors.darkGray,
      luContentLink: baseColors.shock.base,
      gray: baseColors.gray.base,
      attributeLabel: colors.greyishBrown,
      greyishBlue: colors.greyishBlue,
      error: colors.red,
      davysGray: colors.davysGray
    },
    textContrast: {
      light: colors.base,
      dark: colors.black
    },
    background: {
      white: colors.base,
      base: colors.lightSilver,
      lighter: colors.white,
      darker: colors.lightGray,
      dark: colors.gray,
      whisper: colors.whisper,
      primary: colors.blue,
      secondary: colors.lightGray,
      primaryDark: colors.darkBlue,
      limeGreen: colors.limeGreen,
      deepGreen: colors.deepGreen,
      luContentPrimary: baseColors.shock.base,
      overlay: baseColors.overlay.base,
      opacityBlue: colors.opacityBlue,
      magablu: colors.blue,
      magabluDark: colors.darkBlue,
      magabluLight: baseColors.magablu.light
    },
    border: {
      base: colors.silver,
      dark: colors.gray,
      primary: colors.darkBlue,
      light: colors.lightSilver,
      whisper: colors.whisper
    },
    stars: {
      base: baseColors.gold.base,
      disabled: baseColors.gray.light
    },
    icons: {
      base: colors.blue,
      dislike: baseColors.vermillion.base,
      like: baseColors.lima.base,
      disabled: baseColors.gray.light
    }
  };
  return deepmerge(colorPalette, palette);
};

const createTheme = (theme = {}) => {
  const mergedTheme = deepmerge(defaultTheme, theme);
  return Object.assign({}, mergedTheme, {
    palette: createPalette(mergedTheme)
  });
};

export default createTheme;